import styled from "styled-components";

import Icon from "konnekt/Icon";

export const ImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const ImageContainer = styled.div`
  width: calc(100% - 88px);
  padding: 10px;
  height: calc(100vh - 300px);
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-self: center;
  justify-content: center;
  overflow: auto;
  position: relative;

  &:focus {
    outline: none;
  }

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    padding: 0 10px;

    height: calc(100vh - 400px);
  }
`;

export const NavIcon = styled(Icon)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    display: block;
  }
`;
